import { render, staticRenderFns } from "./merchantCourseDetails.vue?vue&type=template&id=65090e25"
import script from "./merchantCourseDetails.vue?vue&type=script&lang=js"
export * from "./merchantCourseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65090e25')) {
      api.createRecord('65090e25', component.options)
    } else {
      api.reload('65090e25', component.options)
    }
    module.hot.accept("./merchantCourseDetails.vue?vue&type=template&id=65090e25", function () {
      api.rerender('65090e25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prepareLesson/merchantCourseDetails.vue"
export default component.exports